<template>
  <div class="mt-component-form">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow"
        >항목추가
        </vs-button>
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow"
        >선택삭제
        </vs-button
        >
      </div>
    </vs-row>
    <div class="form-group grid">
      <div class="overflow-x-auto">
        <div class="form-group__header"
             style="display: grid; grid-template-columns: 40px 1fr 1fr 1fr 1fr 1fr 1fr 260px 1fr 260px; background-color: #f9f9f9">
          <vs-checkbox
            @change="handleCheckAll"
            class="form-group__header-title title-checked"
            :value="allChecked"
          ></vs-checkbox>
          <div class="form-group__header-title">세부작업명</div>
          <div class="form-group__header-title">평가구분</div>
          <div class="form-group__header-title">유해·위험요인</div>
          <div class="form-group__header-title">재해형태</div>
          <div class="form-group__header-title">위험발생 상황 및 결과</div>
          <div class="form-group__header-title">현재 안전보건조치</div>
          <div class="form-group__header-title flex-col">
            <p class="h-full w-full center-flex bb">현재 위험도</p>
            <div class="flex h-full w-full">
              <div class="flex-1 center-flex">
                가능성
                <vx-tooltip title="가능성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip1()"
                  />
                </vx-tooltip>
              </div>
              <div class="flex-1 center-flex bx">
                중대성
                <vx-tooltip title="중대성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip2()"
                  />
                </vx-tooltip>
              </div>
              <div class="flex-1 center-flex">
                위험도
                <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip3()"
                  />
                </vx-tooltip>
              </div>
            </div>
          </div>
          <div class="form-group__header-title">위험감소대책</div>
          <div class="form-group__header-title flex-col">
            <p class="h-full w-full center-flex bb">개선후 위험도</p>
            <div class="flex h-full w-full">
              <div v-if="!hideCodeNumber" class="flex-1 center-flex br">코드번호</div>
              <div class="flex-1 center-flex">
                가능성
                <vx-tooltip title="가능성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip1()"
                  />
                </vx-tooltip>
              </div>
              <div class="flex-1 center-flex bx">
                중대성
                <vx-tooltip title="중대성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip2()"
                  />
                </vx-tooltip>
              </div>
              <div class="flex-1 center-flex">
                위험도
                <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                            style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                            position="top" delay=".1s">
                  <feather-icon icon="AlertCircleIcon"
                                style="cursor: pointer; width:16px;"
                                @click="onClickToolTip3()"
                  />
                </vx-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-group__content"
          style="display: grid; grid-template-columns: 40px 1fr 1fr 1fr 1fr 1fr 1fr 260px 1fr 260px;"
          v-for="(row, rowIndex) in list"
          :key="row.id"
        >
          <vs-checkbox
            class="form-group__content-row row-checked"
            v-model="row.input_check"
            :readonly="readonly"
          ></vs-checkbox>
          <div class="form-group__content-row">
            <p v-if="isPrint">
              {{ row.input_1 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="readonly"
              v-else

              rows="3"
              v-model="row.input_1"
            />
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint" class="w-full flex-1">
              {{ row.input_2 }}
            </p>
            <check-type-a-selector
              v-else
              v-model="row.input_2"
              :readonly="readonly"
              class="w-full"
              @change="handleTypeInput(rowIndex)"
            />
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint">
              {{ row.input_4 }}
            </p>
            <ml-input v-else-if="row.input_2 === '직접입력'" class="w-full" v-model="row.input_4"/>
            <vs-select
              v-else
              class="w-full"
              autocomplete
              v-model="row.input_4"
              :disabled="readonly"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in handleAppraisalType(row.input_2)"
              />
            </vs-select>
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint" class="w-full flex-1">
              {{ row.input_3 }}
            </p>
            <disaster-class-selector
              v-else
              class="w-full"
              v-model="row.input_3"
            />
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint">
              {{ row.input_14 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="readonly"
              v-else

              rows="3"
              v-model="row.input_14"
            />
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint">
              {{ row.input_5 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="readonly"
              v-else

              rows="3"
              v-model="row.input_5"
            />
          </div>
          <div class="form-group__content-row p-0 flex">
            <div class="flex-1 p-2">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.input_6 }}
              </p>
              <vs-select
                v-else
                class="w-full"
                autocomplete
                :disabled="postId"
                v-model="row.input_6"
                @change="handleChangeinput(
                      row.id,
                      row.input_6,
                      row.input_7,
                      'input_8'
                    );

                    // #860qfn7h5 : https://app.clickup.com/t/860qfn7h5
                    // 수정사항에 의해서 신규 작성일 때,
                    // 개선후 위험도를 현재위험도와 싱크 맞추기
                    if (!postId) {
                      list[rowIndex].input_11 = row.input_6
                      list[rowIndex].input_12 = row.input_7
                      handleChangeinput(
                        row.id,
                        row.input_11,
                        row.input_12,
                        'input_13'
                      )
                    }"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in optionsNumber1"
                />
              </vs-select>
            </div>
            <div class="flex-1 p-2 bx">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.input_7 }}
              </p>
              <vs-select
                v-else
                class="w-full"
                autocomplete
                v-model="row.input_7"
                :disabled="postId"
                @change="handleChangeinput(
                      row.id,
                      row.input_6,
                      row.input_7,
                      'input_8'
                    );

                    // #860qfn7h5 : https://app.clickup.com/t/860qfn7h5
                    // 수정사항에 의해서 신규 작성일 때,
                    // 개선후 위험도를 현재위험도와 싱크 맞추기
                    if (!postId) {
                      list[rowIndex].input_11 = row.input_6
                      list[rowIndex].input_12 = row.input_7
                      handleChangeinput(
                        row.id,
                        row.input_11,
                        row.input_12,
                        'input_13'
                      )
                    }"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in optionsNumber2"
                />
              </vs-select>
            </div>
            <div class="flex-1 p-2">
              <p v-if="isPrint" class="w-full flex-1">
                {{ getResultRisk(row.input_8) }}
              </p>
              <ml-input
                :readonly="true"
                class="w-full"
                v-text="getResultRisk(row.input_8)"
                v-else
                :style="{ color: row.input_8_color }"
              />
            </div>
          </div>
          <div class="form-group__content-row">
            <p v-if="isPrint">
              {{ row.input_9 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="readonly"
              v-else

              rows="3"
              v-model="row.input_9"
            />
          </div>
          <div class="form-group__content-row row-w0 p-0 flex">
            <div v-if="!hideCodeNumber" class="flex-1 p-2 br">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.input_10 }}
              </p>
              <ml-input
                :readonly="true"
                class="w-full"
                v-model="row.input_10"
                v-else
              />
            </div>
            <div class="flex-1 p-2" >
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.input_11 }}
              </p>
              <vs-select
                v-else
                class="w-full"
                autocomplete
                v-model="row.input_11"
                :disabled="!postId"
                @change="
                    handleChangeinput(
                      row.id,
                      row.input_11,
                      row.input_12,
                      'input_13'
                    )
                  "
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in optionsNumber1"
                />
              </vs-select>
            </div>
            <div class="flex-1 p-2 bl">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.input_12 }}
              </p>
              <vs-select
                v-else
                class="w-full"
                autocomplete
                v-model="row.input_12"
                :disabled="!postId"
                @change="
                    handleChangeinput(
                      row.id,
                      row.input_11,
                      row.input_12,
                      'input_13'
                    )
                  "
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in optionsNumber2"
                />
              </vs-select>
            </div>
            <div class="flex-1 p-2 bl">
              <p v-if="isPrint" class="w-full flex-1">
                {{ getResultRisk(row.input_13) }}
              </p>
              <ml-input
                :readonly="true"
                class="w-full"
                v-text="getResultRisk(row.input_13)"
                v-else
                :style="{ color: row.input_13_color }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="text-box">-->
<!--      <div class="center-flex h-12 bg-1">-->
<!--        <feather-icon-->
<!--          icon="AlertTriangleIcon"-->
<!--          class="ml-1"-->
<!--          style="width:18px; height:18px;"-->
<!--        />-->
<!--        위험성 결정-->
<!--      </div>-->
<!--      <div class="p-4 text-sm font-medium ">-->
<!--        <p>-->
<!--          ※ 가능성 : 5(매우 높음), 4(높음), 3(보통), 2(낮음), 1(매우 낮음)-->
<!--        </p>-->
<!--        <p>-->
<!--          ※ 중대성 : 4(사망, 장애발생), 3(휴업필요 부상/질병), 2(휴업 불필요-->
<!--          부상/질병), 1(비치료)-->
<!--        </p>-->
<!--        <p>-->
<!--          ※ 위험성 : 가능성 X 중대성-->
<!--        </p>-->
<!--        <p>-->
<!--          ※ 위험성 감소대책 : 위험성이 8 이상인 유해·위험요인에 대해서는 현재-->
<!--          조치되어 있지 않은 위험성 감소대책을 수립·기재-->
<!--        </p>-->
<!--        <p>-->
<!--          ※ 코드NO : (등급)-(연번) ex)A-1, B-2-->
<!--        </p>-->
<!--      </div>-->
<!--    </div>-->
    <popup-risk-info-ep1 v-model="showInfoPopup1"></popup-risk-info-ep1>
    <popup-risk-info-ep2 v-model="showInfoPopup2"></popup-risk-info-ep2>
    <popup-risk-info-ep3 v-model="showInfoPopup3"></popup-risk-info-ep3>
  </div>
</template>

<script>

import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import CheckTypeASelector from '@/components/selector/CheckTypeASelector'
import PopupRiskInfoEp1 from '@/views/project/popup/PopupRiskInfoEp1.vue'
import PopupRiskInfoEp2 from '@/views/project/popup/PopupRiskInfoEp2.vue'
import PopupRiskInfoEp3 from '@/views/project/popup/PopupRiskInfoEp3.vue'
export default {
  name: 'TableRiskAppraisalEp',
  components: {
    PopupRiskInfoEp3,
    PopupRiskInfoEp2,
    PopupRiskInfoEp1,
    CheckTypeASelector,
    DisasterClassSelector,

  },
  props: {
    title: {
      type: String,
      default: () => '4M 위험성 평가표'
    },
    isPrint: Boolean,
    readonly: Boolean,
    hideCodeNumber: Boolean,
    value: Array,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.list = value
      }
    },
    list: {
      immediate: false,
      deep: true,
      handler(value) {
        this.$emit("input", value)
      }
    }
  },
  computed: {
    postId () {
      return this.$route.params.postId
    },
    allChecked () {
      let allCheck = true;
      for (const item of this.list) {
        if (!item.input_check) {
          allCheck = false
          break;
        }
      }
      return allCheck;
    },

  },
  data () {
    return {
      optionsNumber1: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'},
        {value: 5, label: '5'}
      ],
      optionsNumber2: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'}
      ],
      showInfoPopup1: false,
      showInfoPopup2: false,
      showInfoPopup3: false,
      list: []
    }
  },
  methods: {
    getResultRisk (data) {
      switch (data) {
      case 'A': return '매우높음'
      case 'B': return '높음'
      case 'C': return '약간높음'
      case 'D': return '보통'
      case 'E': return '낮음'
      case 'F': return '매우낮음'
      }
    },

    handleCheckAll (e) {
      const checked = e.target.checked
      this.list.forEach(e => {
        e.input_check = checked
      })
    },

    handleAddRow () {
      this.list.push({
        id: this.list.length,
        input_check: false,
        input_1: '',
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_6: 1,
        input_7: 1,
        input_8: 'F',
        input_8_color: '#28C76F',
        input_9: '',
        input_10: 'F-1',
        input_11: 1,
        input_12: 1,
        input_13: 'F',
        input_13_color: '#28C76F',
        input_14: '',
      })
    },
    handleRemoveRow () {
      this.list = this.list.filter(x => x.input_check === false)
    },
    onClickToolTip1 () {
      this.showInfoPopup1 = true
    },
    onClickToolTip2 () {
      this.showInfoPopup2 = true
    },
    onClickToolTip3 () {
      this.showInfoPopup3 = true
    },
    handleChangeinput (id, n1, n2, string) {
      let f = 1
      let e = 1
      let d = 1
      let c = 1
      let b = 1
      let a = 1
      const value = n1 * n2
      const color = `${string}_color`
      const result = this.handleResult(value)
      this.list.forEach((i, index) => {
        for (const key in i) {
          if (key === string && i.id === id) {
            this.list[index][key] = result
            this.list[index][color] = this.checkColor(value)
          }
          if (key.includes('_8')) {
            if (this.list[index][key] === 'F') {
              this.list[index].input_10 = `F-${f}`
              f++
            } else if (this.list[index][key] === 'E') {
              this.list[index].input_10 = `E-${e}`
              e++
            } else if (this.list[index][key] === 'D') {
              this.list[index].input_10 = `D-${d}`
              d++
            } else if (this.list[index][key] === 'C') {
              this.list[index].input_10 = `C-${c}`
              c++
            } else if (this.list[index][key] === 'B') {
              this.list[index].input_10 = `B-${b}`
              b++
            } else if (this.list[index][key] === 'A') {
              this.list[index].input_10 = `A-${a}`
              a++
            }
          }
        }
      })
    },
    checkColor (value) {
      if (value >= 1 && value <= 3) {
        return '#28C76F'
      } else if (value >= 4 && value <= 6) {
        return '#FF8510'
      } else {
        return '#E42728'
      }
    },
    handleResult (result) {
      if (result >= 1 && result <= 3) return 'F'
      else if (result >= 4 && result <= 6) return 'E'
      else if (result === 8) return 'D'
      else if (result >= 9 && result <= 12) return 'C'
      else if (result === 15) return 'B'
      else if (result >= 16 && result <= 20) return 'A'
    },
    handleTypeInput(index) {
      this.list[index].input_4 = ""
    },
    handleAppraisalType (type) {
      if (type === '기계(설비)적 요인') {
        return [
          {text: '끼임(감김)', value: '끼임(감김)'},
          {text: '위험한 표면(절단, 베임, 긁힘)', value: '위험한 표면(절단, 베임, 긁힘)'},
          {text: '기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분', value: '기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분'},
          {text: '충돌위험 부분', value: '충돌위험 부분'},
          {text: '넘어짐(미끄러짐, 걸림, 헛디딤)', value: '넘어짐(미끄러짐, 걸림, 헛디딤)'},
          {text: '추락위험 부분(개구부 등)', value: '추락위험 부분(개구부 등)'},
        ]
      } else if (type === '전기적 요인') {
        return [
          {text: '감전(안전전압초과)', value: '감전(안전전압초과)'},
          {text: '아크', value: '아크'},
          {text: '정전기', value: '정전기'},
          {text: '화재 / 폭발 위험', value: '화재 / 폭발 위험'},
        ]
      } else if (type === '화학(물질)적 요인') {
        return [
          {text: '가스', value: '가스'},
          {text: '증기', value: '증기'},
          {text: '에어로졸·흄', value: '에어로졸·흄'},
          {text: '액체·미스트', value: '액체·미스트'},
          {text: '고체(분진)', value: '고체(분진)'},
          {text: '반응성 물질', value: '반응성 물질'},
          {text: '방사선', value: '방사선'},
          {text: '화재 / 폭발 위험', value: '화재 / 폭발 위험'},
          {text: '복사열 / 폭발과압', value: '복사열 / 폭발과압'},
        ]
      } else if (type === '생물학적 요인') {
        return [
          {text: '병원성 미생물, 바이러스에 의한 감염', value: '병원성 미생물, 바이러스에 의한 감염'},
          {text: '유전자 변형물질(GMO)', value: '유전자 변형물질(GMO)'},
          {text: '알러지 및 미생물', value: '알러지 및 미생물'},
          {text: '동물', value: '동물'},
          {text: '식물', value: '식물'},
        ]
      } else if (type === '작업특성 요인') {
        return [
          {text: '소음', value: '소음'},
          {text: '초음파·초저주파음', value: '초음파·초저주파음'},
          {text: '진동', value: '진동'},
          {text: '근로자 실수(휴먼에러)', value: '근로자 실수(휴먼에러)'},
          {text: '저압 또는 고압상태', value: '저압 또는 고압상태'},
          {text: '질식위험·산소결핍', value: '질식위험·산소결핍'},
          {text: '중량물 취급작업', value: '중량물 취급작업'},
          {text: '반복작업', value: '반복작업'},
          {text: '불안정한 작업자세', value: '불안정한 작업자세'},
          {text: '작업(조작)도구', value: '작업(조작)도구'},
          {text: '기후 / 고온 / 한랭', value: '기후 / 고온 / 한랭'},
        ]
      } else if (type === '작업환경 요인') {
        return [
          {text: '기후 / 고온 / 한랭', value: '기후 / 고온 / 한랭'},
          {text: '조명', value: '조명'},
          {text: '공간 및 이동통로', value: '공간 및 이동통로'},
          {text: '주변 근로자', value: '주변 근로자'},
          {text: '작업시간', value: '작업시간'},
          {text: '조직 안전문화', value: '조직 안전문화'},
          {text: '화상', value: '화상'},
          {text: '작업(조작) 도구', value: '작업(조작) 도구'},
        ]
      }

    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bl {
  border-left: $border;
}

.bb {
  border-bottom: $border;
}
</style>

